// tslint:disable:no-bitwise
var UtilUUID = /** @class */ (function () {
    function UtilUUID() {
        this.uuidv4 = function () {
            return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function (c) {
                var r = (Math.random() * 16) | 0;
                var v = c === "x" ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        };
    }
    return UtilUUID;
}());
export var utilUUID = new UtilUUID();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilUUID.ts
// module id = 1783
// module chunks = 3